export default __webpack_public_path__ + "9068d5bac2270e76a64f9a786613d5ac.png";